module.exports = __webpack_public_path__ + "img/s1MRLine.31477984.svg";